import React from 'react'

import { reverse } from 'named-urls'

import { Typography } from '@material-ui/core'

import { routes } from 'routes'
import { DotStatus } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import helpers from 'helpers'
import usePermissions from 'hooks/usePermissions'

import styles from './styles'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(styles)

const TableRowClient = ({ customer, ...rest }) => {
  const classes = useStyles()

  return (
    <TableRow {...rest}>
      <TableCell>{customer.id}</TableCell>
      <TableCell className={classes.tableCellName}>
        <Typography noWrap>
          {helpers.people.isCompany(customer.kind)
            ? customer.tradeName || customer.companyName
            : customer.name}
        </Typography>
      </TableCell>
      <TableCell>{customer.email}</TableCell>
      <TableCell>{helpers.people.kind(customer.kind)}</TableCell>
      <TableCell>
        {helpers.people.isCompany(customer.kind)
          ? helpers.people.formatCnpj(customer.cnpj)
          : helpers.people.formatCpf(customer.cpf)}
      </TableCell>
      <TableCell align="center">
        <DotStatus
          statusName={customer.active ? 'Ativo' : 'Inativo'}
          statusTag={customer.active ? 'active' : 'inactive'}
        />
      </TableCell>
    </TableRow>
  )
}

const ClientsTable = ({ customers, isLoading }) => {
  const permissions = usePermissions()
  const permittedShowCustomer = permissions.permitted('show_customer')

  return (
    <Table
      size="medium"
      emptyMessage="Nenhum cliente encontrado"
      isLoading={isLoading}
      noWrap
    >
      <TableHead>
        <TableRow>
          <TableCell width="20%">Identificador</TableCell>
          <TableCell width="20%">Nome/Fantasia</TableCell>
          <TableCell width="20%">Email</TableCell>
          <TableCell width="10%">Tipo</TableCell>
          <TableCell width="20%">Documento</TableCell>
          <TableCell width="10%" align="center">
            Status
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {customers &&
          customers.map(customer => (
            <TableRowClient
              customer={customer}
              pointer={permittedShowCustomer}
              to={
                permittedShowCustomer &&
                reverse(routes.clients.show, { clientId: customer.id })
              }
              key={customer.id}
              hover
            />
          ))}
      </TableBody>
    </Table>
  )
}

export default ClientsTable
